enum BodySize {
  body = 'body1',
  body2 = 'body2',
  caption = 'caption',
}

type SiteCoreTypographyData = {
  fontFamilyType: {
    name: string;
  };
  fontSize: {
    value: string;
  };
  fontColor: {
    value: string;
  };
  fontWeight: {
    value: string;
  };
  fontFace?: {
    value: string;
  };
  tabletFontSize: {
    value: string;
  };
  mobileFontSize: {
    value: string;
  };
  isApplicableToRichText?: {
    value: boolean;
  };
};

enum FontFamilyEnum {
  Primary = 'Primary',
  PrimaryBold = 'Primary Bold',
  PrimarySemiBold = 'Primary SemiBold',
  PrimaryRegular = 'Primary Regular',
  Secondary = 'Secondary',
  SecondaryBold = 'Secondary Bold',
  SecondarySemiBold = 'Secondary SemiBold',
  SecondaryRegular = 'Secondary Regular',
}

type TypographyStyle = {
  fontSize: {
    regular: string;
    tablet: string;
    mobile: string;
  };
  color: string;
  fontFamily: string;
  fontWeight: number;
};

export type { SiteCoreTypographyData, TypographyStyle };
export { FontFamilyEnum, BodySize };
